import React from 'react';
import { motion } from 'framer-motion';
import { Cabin } from '../types/cabin';
interface FeaturedCabinCardProps {
  cabin: Cabin;
  variant?: 'primary' | 'secondary';
  onSelect: (id: string) => void;
}
export function FeaturedCabinCard({
  cabin,
  variant = 'primary',
  onSelect
}: FeaturedCabinCardProps) {
  const heightClasses = variant === 'primary' ? 'h-[320px] sm:h-[440px] lg:h-[560px]' : 'h-[260px] sm:h-[380px]';
  return <motion.div initial={{
    opacity: 0,
    y: 35
  }} whileInView={{
    opacity: 1,
    y: 0
  }} viewport={{
    once: true,
    margin: '-40px'
  }} transition={{
    duration: 0.8,
    ease: [0.25, 0.46, 0.45, 0.94]
  }} onClick={() => onSelect(cabin.id)} role="button" tabIndex={0} onKeyDown={e => {
    if (e.key === 'Enter') onSelect(cabin.id);
  }} className={`group relative w-full ${heightClasses} rounded-[40px] overflow-hidden mb-6 cursor-pointer`} data-id="element-172" data-mp="yho4xnemklll">
      <img src={cabin.image} alt={cabin.name} className="absolute inset-0 w-full h-full object-cover transition-transform duration-[900ms] ease-out group-hover:scale-[1.04]" style={{
      objectPosition: variant === 'primary' ? 'center 30%' : 'center 45%'
    }} data-id="element-173" data-mp="3e9vjszjah2if" />
      <div className="absolute inset-0 bg-gradient-to-t from-black/85 via-black/10 to-transparent" data-id="element-174" data-mp="1xvd254wmajqf" />
      {cabin.badge && <span className="absolute top-7 left-7 bg-gold text-night px-4 py-1.5 rounded-full text-[0.67rem] font-bold tracking-[0.12em] uppercase" data-id="element-175" data-mp="1tqvjxa5woehr">
          {cabin.badge}
        </span>}
      <div className="absolute bottom-0 left-0 right-0 p-6 sm:p-10 flex flex-col sm:flex-row items-start sm:items-end justify-between gap-4 sm:gap-8" data-id="element-176" data-mp="2lkxo7wo2hx3x">
        <div data-id="element-177" data-mp="2ck95wprn5al8">
          <h3 className="font-display text-3xl sm:text-4xl lg:text-5xl font-light text-white mb-2" data-id="element-178" data-mp="2ciemjfw0pqj9">{cabin.name}</h3>
          {cabin.shortDescription && <p className="text-sm text-white/60 leading-relaxed max-w-md" data-id="element-179" data-mp="114atcbx986f9">{cabin.shortDescription}</p>}
          {cabin.tags && <div className="flex gap-2 flex-wrap mt-3" data-id="element-180" data-mp="12mhq2e8j5nom">
              {cabin.tags.map(tag => <span key={tag} className="bg-white/10 border border-white/20 text-white/80 px-3 py-1 rounded-full text-xs" data-id="element-181" data-mp="17jhw4p5dqqfq">
                  {tag}
                </span>)}
            </div>}
        </div>
        <a href="#reserva" onClick={e => e.stopPropagation()} className="inline-flex items-center gap-2 bg-gold text-night px-7 py-3.5 rounded-full text-xs font-semibold tracking-wide uppercase transition-all hover:bg-gold-light hover:-translate-y-0.5 hover:shadow-[0_15px_40px_rgba(201,169,110,0.45)] whitespace-nowrap" data-id="element-182" data-mp="juoz0pd0ucjj">
          Consultar
        </a>
      </div>
    </motion.div>;
}